import React from 'react';
import { AiOutlineClear } from 'react-icons/ai';

/**
 * O componente ClearFiltersButton renderiza um botão para limpar filtros memorizados.
 *
 * @component
 * @param {Object} props - As propriedades para o componente.
 * @param {string} [props.textButton='Limpar Filtros'] - O texto a ser exibido no botão.
 * @param {ReactNode} [props.Icon] - Um ícone opcional a ser exibido ao lado do texto do botão.
 * @param {Object} [props.styles] - Estilos personalizados para o contêiner do botão.
 * @param {function} props.handleOnClick - A função a ser chamada quando o botão for clicado.
 *
 * @returns {JSX.Element} O componente do botão renderizado.
 */
export function ClearFiltersButton({
  textButton = 'Limpar Filtros',
  Icon,
  styles: { position = 'absolute', right = '1rem', top = '1.5rem' } = {},
  handleOnClick
}) {
  return (
    <div style={{ position, right, top }}>
      <span
        onClick={handleOnClick}
        className="small"
        style={{ cursor: 'pointer' }}
      >
        {Icon ?? <AiOutlineClear />} {textButton}
      </span>
    </div>
  );
}
